'use strict';

import util from './util';
import validator from './validator';
import modalExport from './modal';
const modal = modalExport.global;

function showNewsletterModal() {
	
        modal.events.onClose(function () {            
            util.setCookie(Constants.COOKIENAME_SESSION_FLAG, false, 10);
        });

        modal.renderByUrl(Urls.showFullNewsletterForm)
            .done(function (response) {
                modal.addCustomClass('newsletter-signup-modal');
                

                validator.initForm('.newsletter-signup-modal form');
        });
}

function isNewsletterEnabled() { 
    $('.register-newsletter').removeClass('hide');
    $('.newsletter-success').addClass('hide');
    
    if (!enableNewsletter || window.User.disableNewsletterOverlayFlag == true) {
        return;
    }
    
    var isViewedNewsletterValid = util.getCookieSelector(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG);   
    
    var isDisplayedNewsletterValid = util.getCookieSelector(Constants.COOKIENAME_SESSION_FLAG);

    if (isDisplayedNewsletterValid === 'false' || window.pageContext.ns == 'cart' || window.pageContext.ns == 'checkout') {
        return;
    }

    util.setCookie(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG, false, newsletterCookieDuration);
    
    setNewsletterCounterCookie();
}

function setNewsletterCounterCookie() {
    var isCookieValid = util.getCookieSelector(Constants.COOKIENAME_NEWSLETTER_PAGEVIEW_COUNT),
    	counterCookie = Number(isCookieValid),
    	isPreferredCountry = util.getCookieSelector([siteId, 'preferredSite'].join('-')),
    	isPreferredLocale = util.getCookieSelector([siteId, 'preferredLocale'].join('-')); 

    if (!isCookieValid) {
        counterCookie = 0;
    } else {
        counterCookie += 1;
    }

    util.setCookie(Constants.COOKIENAME_NEWSLETTER_PAGEVIEW_COUNT, counterCookie, newsletterCookieDuration);
    
    var newsletterPageCount = util.getCookieSelector(Constants.COOKIENAME_NEWSLETTER_PAGEVIEW_COUNT);
    var cookieConcentFlag = util.getCookieSelector(Constants.COOKIENAME_COOKIECONSENT_FLAG);
    var sessionConcentFlag = util.getCookieSelector(Constants.COOKIENAME_SESSION_FLAG);
    
    if (cookieConcentFlag == 'true' && sessionConcentFlag == 'true' && enabledPopUpFlag && counterCookie >= newsletterPageCount && isPreferredCountry !== "" && isPreferredLocale !== "" && $('.calendarlayout').length == 0) {
       showNewsletterModal();
    }
}

function signUpEventListener() {
    $(document)
        .on('submit', '.modal-content .news-letter-form', function (e) {
            e.preventDefault();

            $(this).find(':input[type=submit]').prop('disabled', true);
            var emailAddress = $('.modal-content input[name*="email"]').val();
            validateNewsletterEmail(true, emailAddress);
        })

        .on('keyup blur', '.modal-content input', function (e) {
            var emailAddress = $(this).val();

            $('.modal-content button').prop('disabled', false);
            $('.modal-content button').css('color', '');
        });
}

function newsletterHeader() {
	
    $(document).on('submit', '.newsletter-content .news-letter-form', function (e) {
        e.preventDefault();

        $(this).find(':input[type=submit]').prop('disabled', true);
        $(this).find('.email-button').addClass('disabled');
         
        var emailAddress = $('.newsletter-content .news-letter-form input[name="email"]').val();
        var source = $('.newsletter-content .news-letter-form input[name="source"]').val();
        var parentdiv = '.newsletter-content';
        validateNewsletterEmail(false, emailAddress, source, parentdiv);
    });
        
}

function newsletterPersistentFooter() {
    $(document).on('submit', '.newsletter-persistent-footer .news-letter-form', function (e) { 
        e.preventDefault();

        var emailAddress = $('.newsletter-persistent-footer .news-letter-form input[name="email"]').val();
        var source = $('.newsletter-persistent-footer .news-letter-form input[name="source"]').val();
        var parentdiv = '.newsletter-persistent-footer';
        validateNewsletterEmail(false, emailAddress,source, parentdiv);
    });
}

function offerNewsletter() {	
    $(document).on('submit', '.offers-newsletter-bloc .offers-news-letter-form', function (e) {
        e.preventDefault();    
        $(this).find(':input[type=submit]').prop('disabled', true);
        var emailAddress = $('.offers-newsletter-bloc .offers-news-letter-form input[name="email"]').val();
        var source = $('.offers-newsletter-bloc .offers-news-letter-form input[name="source"]').val();
        var parentdiv = '.newsletter-content';
        validateNewsletterEmail(false, emailAddress, source, parentdiv);
    });
}

function validateNewsletterEmail(isModal, emailAddress, source, parentdiv) {
	var validateClass = "";
	if(parentdiv == ".newsletter-module") {
		validateClass = parentdiv+' .newsletter-form';
	}else {
		validateClass = parentdiv+' .news-letter-form';
	}
    

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
        
    var postData = ['dwfrm_newsletter_email=', emailAddress].join('');
    var dataObj = {
            email: emailAddress,
            source: isModal ? 'modal' : source
        };
    var formAction = $('.newsletter-container form').attr('action');
    if(parentdiv == ".newsletter-module") {
    	formAction = $('.newsletter-form-container form').attr('action');
    }
    //add fname and lname if newsletter fro footer has been clicked
    if (source == 'footer') {  
    	if(parentdiv == ".newsletter-module") {
    		postData += $('#dwfrm_newsletter_firstName') != undefined ? $('#dwfrm_newsletter_firstName').val() : '' ;
        	postData += $('#dwfrm_newsletter_lastName') != undefined ? $('#dwfrm_newsletter_lastName').val() : '' ;
        	postData += $('#dwfrm_newsletter_customer_birthmonth') != undefined ? $('#dwfrm_newsletter_customer_birthmonth').val() : '' ;
        	postData += $('#dwfrm_newsletter_customer_dob') != undefined ? $('#dwfrm_newsletter_customer_dob').val() : '' ;
        	postData += $('#dwfrm_newsletter_customer_birthyear') != undefined ? $('#dwfrm_newsletter_customer_birthyear').val() : '' ;
        	dataObj.firstName = $('#dwfrm_newsletter_firstName') != undefined ? $('#dwfrm_newsletter_firstName').val() : '' ;
        	dataObj.lastName = $('#dwfrm_newsletter_lastName') != undefined ? $('#dwfrm_newsletter_lastName').val() : '' ;
        	dataObj.birthday = $('#dwfrm_newsletter_customer_dob') != undefined ? $('#dwfrm_newsletter_customer_dob').val() : '' ;
        	dataObj.birthmonth = $('#dwfrm_newsletter_customer_birthmonth') != undefined ? $('#dwfrm_newsletter_customer_birthmonth').val() : '' ;
        	dataObj.birthyear = $('#dwfrm_newsletter_customer_birthyear') != undefined ? $('#dwfrm_newsletter_customer_birthyear').val() : '' ;
        	var servicesOpted = [];
        	$('.profile-optin-checkboxes input[type=checkbox]').each(function () {
         	   if(this.checked) {
         		  servicesOpted.push($(this).val());
         	   }
         	});
        	dataObj.servicesOpted = servicesOpted.join().toString();
    	}else {
    		postData += $('#newsletter-firstname-footer') != undefined ? ['&dwfrm_newsletter_firstName=', $('#newsletter-firstname-footer').val()].join('') : '' ;
        	postData += $('#newsletter-lastname-footer') != undefined ? ['&dwfrm_newsletter_lastName=', $('#newsletter-lastname-footer').val()].join('') : '' ;
        	dataObj.firstName = $('#newsletter-firstname-footer') != undefined ? $('#newsletter-firstname-footer').val() : '' ;
        	dataObj.lastName = $('#newsletter-lastname-footer') != undefined  ? $('#newsletter-lastname-footer').val() : '' ;
    	}
    } else if (source == 'offers') {
        postData += $('.offers-news-letter-form input[name="firstname"]') != undefined ? ['&dwfrm_newsletter_firstName=', $('.offers-news-letter-form input[name="firstname"]').val()].join('') : '' ;
        postData += $('.offers-news-letter-form input[name="lastname"]') != undefined ? ['&dwfrm_newsletter_lastName=', $('.offers-news-letter-form input[name="lastname"]').val()].join('') : '' ;
        dataObj.firstName = $('.offers-news-letter-form input[name="firstname"]') != undefined ? $('.offers-news-letter-form input[name="firstname"]').val() : '' ;
        dataObj.lastName = $('.offers-news-letter-form input[name="lastname"]') != undefined  ? $('.offers-news-letter-form input[name="lastname"]').val() : '' ;
    } else if (isModal) {  	  
    	postData += $('#dwfrm_newsletter_firstName') != undefined ? ['&dwfrm_newsletter_firstName=', $('.newsletter-signup-modal #dwfrm_newsletter_firstName').val()].join('') : '' ;
    	postData += $('#dwfrm_newsletter_lastName') != undefined ? ['&dwfrm_newsletter_lastName=', $('.newsletter-signup-modal #dwfrm_newsletter_lastName').val()].join('') : '' ;
    	dataObj.firstName = $('#dwfrm_newsletter_firstName') != undefined ? $('.newsletter-signup-modal #dwfrm_newsletter_firstName').val() : '' ;
    	dataObj.lastName = $('#dwfrm_newsletter_lastName') != undefined ?  $('.newsletter-signup-modal #dwfrm_newsletter_lastName').val() : '' ; 
    }
    else{
        postData += $('#dwfrm_newsletter_firstName') != undefined ? ['&dwfrm_newsletter_firstName=', $('#dwfrm_newsletter_firstName').val()].join('') : '' ;
    	postData += $('#dwfrm_newsletter_lastName') != undefined ? ['&dwfrm_newsletter_lastName=', $('#dwfrm_newsletter_lastName').val()].join('') : '' ;
    	dataObj.firstName = $('#dwfrm_newsletter_firstName') != undefined ? $('#dwfrm_newsletter_firstName').val() : '' ;
    	dataObj.lastName = $('#dwfrm_newsletter_lastName') != undefined ?  $('#dwfrm_newsletter_lastName').val() : '' ;	
    }
        $.ajax({
            type: 'POST',
            url: formAction,
            data: postData,
            success: function(textStatus) {
                $('.register-newsletter').addClass('hide');
                $('.newsletter-success').removeClass('hide');
                $('.newsletter-success').addClass('show');
                $('.newsletter-success .registered-email').html(emailAddress);
            }
        });
    if (isModal) {
        setHasViewedNewsletterCookie(true);
    }
    $.ajax({
        type: 'POST',
        url: $('.news-letter-form').attr('action'),
        data: dataObj,
        success: function (response) {
            if (isModal) {
                modal.renderContent(response);
                modal.addCustomClass('newsletter-signup-modal');
                $(document).trigger("clicknewsletter",{"siteloc":"pop-up"});
                if($('input[id="promo-code"]').val() == '') {
                    $('.promo-wrapper').hide();
                }
                else {
                    $('.promo-wrapper').show();
                }
            } else {
                $(parentdiv).html(response);
                $(document).trigger("clicknewsletter",{"siteloc":"footer"});
            }
        }
    });
}

function setHasViewedNewsletterCookie(val) {    
    util.setCookie(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG, val, newsletterCookieDuration);
}

function newsletterMobile(){
	$(document).on('click', '.newsletter-mobile', function (e) {
		e.preventDefault();
        const element = document.querySelector(".footer-newsletter-section");
        $('.mobile-navigation .close-menu-overlay').trigger('click'); 
        setTimeout(() => {
            element.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
        }, 500);
		
	});
}

export default {
    isNewsletterEnabled,
    newsletterHeader,
    newsletterPersistentFooter,
    newsletterMobile,
    signUpEventListener,
    offerNewsletter,
    validateNewsletterEmail
};